/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Manual_HelpInputs */



/**
* | output |
* | --- |
* | "New Event Groups are created based on the segmentation data provided by the user." |
*
* @param {Segment_Event_Group_Manual_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_manual_help = /** @type {((inputs?: Segment_Event_Group_Manual_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Manual_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("De nouveaux groupes d'evenements sont crees en fonction des donnees de segmentation fournies par l'utilisateur.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Ereignisgruppen werden auf Basis der vom Benutzer bereitgestellten Segmentierungsdaten erstellt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I nuovi gruppi di eventi vengono creati in base ai dati di segmentazione forniti dall'utente.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новые группы событий создаются на основе данных сегментации, предоставленных пользователем.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se crean nuevos grupos de eventos según los datos de segmentación proporcionados por el usuario.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根据用户提供的细分数据创建新的事件组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザーが提供するセグメンテーション データに基づいて、新しいイベント グループが作成されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता द्वारा प्रदान किए गए विभाजन डेटा के आधार पर नए इवेंट समूह बनाए जाते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novos grupos de eventos são criados com base nos dados de segmentação fornecidos pelo usuário.")
	return /** @type {LocalizedString} */ ("New Event Groups are created based on the segmentation data provided by the user.")
});